import type { BalanceProtocol, ProtocolId } from "../types";
import { andProtocol } from "./and";
import { genericProtocol } from "./generic";
import { mtSicsProtocol } from "./mtSics";

export const PROTOCOLS: Record<ProtocolId, BalanceProtocol> = {
  and: andProtocol,
  "mt-sics": mtSicsProtocol,
  generic: genericProtocol,
};

export { andProtocol, genericProtocol, mtSicsProtocol };
